// Plan 08-02 — module-level navigation bridge.
//
// AuthProvider sits ABOVE the Router in the React tree (auth gates routing,
// not the other way around), so the Provider cannot consume useRouter().
// Instead, the Router registers its `navigate` callback into this module
// on mount; AuthProvider calls `navigateTo(path)` which delegates to the
// registered callback (or falls back to a raw `history.pushState` +
// popstate dispatch if the Router has not mounted yet).

let registered: ((path: string) => void) | null = null

export function registerRouterNavigate(fn: (path: string) => void): void {
  registered = fn
}

export function unregisterRouterNavigate(fn: (path: string) => void): void {
  if (registered === fn) registered = null
}

export function navigateTo(path: string): void {
  if (registered) {
    registered(path)
    return
  }
  // Fallback path: raw History API + popstate dispatch.
  if (typeof window !== 'undefined') {
    window.history.pushState(null, '', path)
    window.dispatchEvent(new PopStateEvent('popstate'))
  }
}
